import { MediaManagerTemplateDto } from '../interfaces/supabase/media-manager/dto';
import { MediaManagerTemplate } from '../interfaces/supabase/media-manager/entity';

const mediaManagerTemplateDataMapper = (template: MediaManagerTemplateDto): MediaManagerTemplate => {
  const { created_at, updated_at, tournament_id, sport_type, ...rest } = template;

  return {
    ...rest,
    createdAt: created_at,
    updatedAt: updated_at,
    tournamentId: tournament_id,
    sportType: sport_type,
  };
};

export default mediaManagerTemplateDataMapper;
